export default __webpack_public_path__ + "static/media/jerry.93ed5427.png";